import { css } from "@emotion/css";

import { CHAT_HISTORY_DIALOG_BAR_HEIGHT } from "../ChatHistoryBar/ChatHistoryBar.styles";
import { theme } from "../../utils/theme";

export const CHAT_HISTORY_DIALOG_HEADER_HEIGHT = 52;

export const chatHistoryPanelCSS = css`
  padding: 1.5rem;

  .spark-accordion {
    display: none;
  }

  &.open {
    background-color: ${theme.palette.gray[10]};
    width: 360px;
    overflow: auto;

    .spark-accordion {
      display: block;
    }
  }

  & .spark-collapse-button.spark-btn--icon {
    border: 2px solid ${theme.palette.gray[10]} !important;
  }

  & .spark-accordion__header,
  & .spark-accordion {
    background-color: transparent;
    box-shadow: none;
    overflow: visible;
  }

  .spark-accordion__content {
    background-color: transparent;
    padding: 0;
    box-shadow: none !important;
    overflow: visible;

    &::before,
    &::after {
      margin: 0;
      height: 0;
    }
  }

  .spark-accordion__header {
    padding-left: 0;

    &::after {
      right: 0.5rem !important;

      &:focus {
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px ${theme.palette.gray[10]};
      }
    }

    &[aria-expanded="false"]::after {
      background-color: ${theme.palette.gray[10]} !important;
    }

    h3 span {
      font-weight: 400;
    }
  }

  .spark-accordion__drawer:last-of-type .spark-accordion__content::after {
    background-color: transparent;
  }
`;

export const chatHistoryPanelInDialogCSS = css`
  position: absolute;
  top: ${CHAT_HISTORY_DIALOG_BAR_HEIGHT + CHAT_HISTORY_DIALOG_HEADER_HEIGHT}px;
  box-shadow: none;
  left: -100%;
  width: 100%;
  height: calc(
    100% - ${CHAT_HISTORY_DIALOG_BAR_HEIGHT}px -
      ${CHAT_HISTORY_DIALOG_HEADER_HEIGHT}px
  );
  max-width: 400px;
  overflow: auto;
  padding: 1.5rem;
  transition: 0.4s ease-in-out left;
  z-index: 11;
  background-color: ${theme.palette.gray[10]};
  border-top: 1px solid transparent;

  .spark-accordion {
    display: block;
  }

  &.open {
    width: 100%;
    max-width: 400px;
    left: 0;
    box-shadow: 0px 4px 8px 1px rgba(0, 0, 0, 0.2);
    border-top: 1px solid ${theme.palette.gray[20]};
  }
`;
